/** Eingangsrechnungen (R93–R97): Upload als rohes PDF, Prüfen, Festschreiben, Verwerfen, Abgleich, Kennzahlen. */
import type { EingangStatus, EingangsAbgleich, EingangsrechnungDetail, EingangsrechnungZeile, KostenMonat } from '@storeos/contracts';
import { api, post } from '../api';
import { qs } from './http';

export const eingangsrechnungen = (f: { status?: string } = {}) => api<{ eintraege: EingangsrechnungZeile[]; gesamt: number }>(`/eingangsrechnungen${qs(f)}`);
export const eingangsrechnung = (id: string) => api<EingangsrechnungDetail>(`/eingangsrechnungen/${id}`);
export const eingangAbgleich = (id: string) => api<EingangsAbgleich>(`/eingangsrechnungen/${id}/abgleich`);
export const eingangKennzahlen = () => api<{ monate: KostenMonat[] }>('/eingangsrechnungen/kennzahlen');
export const eingangPdfPfad = (id: string) => `/eingangsrechnungen/${id}/pdf`;

/** Upload: Body = PDF-Bytes, Dateiname im Header (URL-kodiert). CSRF-Token setzt api() wie bei jedem POST. */
export const eingangHochladen = (datei: File) => api<EingangsrechnungDetail>('/eingangsrechnungen', {
  method: 'POST', body: datei, headers: { 'Content-Type': 'application/pdf', 'X-Dateiname': encodeURIComponent(datei.name) },
});
export const eingangPruefen = (id: string, grund?: string) => post<EingangsrechnungDetail>(`/eingangsrechnungen/${id}/pruefen`, { grund: grund ?? null });
export const eingangFestschreiben = (id: string) => post<EingangsrechnungDetail>(`/eingangsrechnungen/${id}/festschreiben`, {});
export const eingangVerwerfen = (id: string, grund: string) => post<EingangsrechnungDetail>(`/eingangsrechnungen/${id}/verwerfen`, { grund });

/** PDF als Blob mit festem Typ (kein Sniffing); Anzeige im iframe über eine blob:-URL (Caddy setzt X-Frame-Options DENY). */
export async function eingangPdfBlob(id: string): Promise<Blob> {
  const r = await fetch(`/api${eingangPdfPfad(id)}`, { credentials: 'same-origin' });
  if (!r.ok) throw new Error(`PDF nicht geladen (${r.status})`);
  return new Blob([await r.arrayBuffer()], { type: 'application/pdf' });
}

export type { EingangStatus };
